import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './LoadingModal.css'
class DGRLoadingModal extends Component {

    render() {
       if (this.props.DGRStore.inProgress || this.props.DGRProductStore.inProgress ){
        return (
              <div className="dgr dgrLoading">
                <div className="bgImages">
                  <div className="hero"></div>
                  <div className="darken"></div>
                  <div className="appLoadingSpinner">
                    <div className="loader">
                    </div>
                      <span className="loadingText">{this.props.DGRStore.loaderText}</span>

                  </div>
                </div>
              </div>
        )
       }else{
       return(
            <div className="">
            </div>
       )
       }
    }
}


DGRLoadingModal = inject('DGRProductStore','DGRStore')(observer(DGRLoadingModal))
export default DGRLoadingModal



// WEBPACK FOOTER //
// ./src/components/DGR/LoadingModal/LoadingModal.js